import { createAction } from '@reduxjs/toolkit';

export const nativeClientPushNotificationReceived = createAction(
    'NATIVE_CLIENT::PUSH_NOTIFICATION_RECEIVED',
);

export const registerForPushNotifications = createAction(
    'NATIVE_CLIENT::REGISTER_FOR_PUSH_NOTIFICATIONS',
);

export const registerForPushNotificationsSuccess = createAction(
    'NATIVE_CLIENT::REGISTER_FOR_PUSH_NOTIFICATIONS::SUCCESS',
);
